import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'

import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { ListasPreciosCabecerasDialogComponent } from './listas-precios-cabeceras-dialog.component';
import { ListasPreciosItemsDialogComponent } from './listas-precios-items-dialog.component';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Proceso } from 'src/app/shared/models/proceso';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { ExcelService } from 'src/app/shared/services/excel.service';

@Component({
  selector: 'app-listas-precios-dialog',
  templateUrl: './listas-precios.component.html'
})
export class ListasPreciosComponent implements OnInit, AfterViewInit {

  @ViewChild('matSortCabeceras') matSortCabeceras: MatSort;
  @ViewChild('matSortItems') matSortItems: MatSort;
  @ViewChild('matPaginatorItems') matPaginatorItems: MatPaginator;
  @ViewChild('matPaginatorCabeceras') matPaginatorCabeceras: MatPaginator;

  displayedColumnsCabeceras = ['acciones', 'idCompania', 'idSalesOrg', 'id', 'descripcion', 'formaPago', 'terminoPago', 'fechaValidaDesde', 'fechaValidaHasta', 'descuentoDiscrecional', 'precioFijo', 'habilitacion'];
  dataSourceCabeceras = new MatTableDataSource<ListaPrecioCabecera>();
  displayedColumnsItems = ['acciones', 'idProducto', 'descripcion', 'tasa', 'idUnidadCondicion', 'lineaProducto', 'fechaValidaDesde', 'fechaValidaHasta', 'habilitacion'];
  dataSourceItems = new MatTableDataSource<ListaPrecioItem>();

  cabSeleccionada: ListaPrecioCabecera;

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    public exporExcelService: ExcelService,
    private productosService: ProductosService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService) { }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }

  public Etiquetas: {
    BotonACabecera: string;
    Buscar: string,
    SinRegistros: string,
    Titulo: string,
    Cabeceras: {
      Headers: {
        Acciones: string
        Descripcion: string,
        DescuentoDiscrecional: string,
        FechaValidaDesde: string,
        FechaValidaHasta: string,
        FormaPago: string,
        Habilitacion: string,
        Id: string,
        IdCompania: string,
        IdSalesOrg: string,
        PrecioFijo: string,
        TerminoPago: string,
      }
    }
    Items: {
      Headers: {
        Acciones: string
        Descripcion: string,
        FechaValidaDesde: string,
        FechaValidaHasta: string,
        Habilitacion: string,
        Id: string,
        IdMoneda: string,
        IdUnidadMedidaBase: string,
        IdListaPrecio: string,
        LineaProducto: string,
        Tasa: string,
      }
    }


  }


  ngAfterViewInit() {
    this.dataSourceCabeceras.paginator = this.matPaginatorCabeceras;
    this.dataSourceCabeceras.sort = this.matSortCabeceras;
    this.dataSourceCabeceras.sort.disableClear = true;

    this.dataSourceItems.paginator = this.matPaginatorItems;
    this.dataSourceItems.sort = this.matSortItems;
    this.dataSourceItems.sort.disableClear = true;

  }

  ngOnInit() {
    if (!this.loggedService.isInRole('ADM') && ! this.loggedService.isInRole('ADM LOCAL') && !this.loggedService.isInRole('ADMVENTAS') && !this.loggedService.isInRole('LOGISTICA')) {
      this.router.navigateByUrl('');
    }

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Ver: this.configService.tooltips.Ver
    }
    this.Etiquetas = {
      Titulo: this.configService.etiquetas.ListasPrecios.Titulo,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Buscar: this.configService.etiquetas.Buscar,
      BotonACabecera: this.configService.etiquetas.ListasPrecios.BotonACabecera,
      Cabeceras: {
        Headers: {
          Acciones: this.configService.etiquetas.Acciones,
          Descripcion: this.configService.etiquetas.Descripcion,
          Id: this.configService.etiquetas.Codigo,
          IdCompania: this.configService.etiquetas.Compania,
          IdSalesOrg: this.configService.etiquetas.SalesOrg,
          Habilitacion: this.configService.etiquetas.Habilitacion,
          DescuentoDiscrecional: this.configService.etiquetas.ListasPrecios.Cabeceras.DescuentoDiscrecional,
          FormaPago: this.configService.etiquetas.ListasPrecios.Cabeceras.FormaPago,
          TerminoPago: this.configService.etiquetas.ListasPrecios.Cabeceras.TerminoPago,
          PrecioFijo: this.configService.etiquetas.ListasPrecios.Cabeceras.PrecioFijo,
          FechaValidaDesde: this.configService.etiquetas.ListasPrecios.Cabeceras.FechaValidaDesde,
          FechaValidaHasta: this.configService.etiquetas.ListasPrecios.Cabeceras.FechaValidaHasta
        }
      },
      Items: {
        Headers: {
          Acciones: this.configService.etiquetas.Acciones,
          Descripcion: this.configService.etiquetas.Descripcion,
          Id: this.configService.etiquetas.Codigo,
          Habilitacion: this.configService.etiquetas.Habilitacion,
          Tasa: this.configService.etiquetas.ListasPrecios.Items.Tasa,
          LineaProducto: this.configService.etiquetas.ListasPrecios.Items.LineaProducto,
          IdMoneda: this.configService.etiquetas.ListasPrecios.Items.Moneda,
          IdUnidadMedidaBase: this.configService.etiquetas.ListasPrecios.Items.IdUnidadMedidaBase,
          IdListaPrecio: this.configService.etiquetas.ListasPrecios.Items.ListaPrecio,
          FechaValidaDesde: this.configService.etiquetas.ListasPrecios.Items.FechaValidaDesde,
          FechaValidaHasta: this.configService.etiquetas.ListasPrecios.Items.FechaValidaHasta
        }

      }
    }
    this.cCabeceras(0);
  }

  cCabeceras(idTipoMensaje: number) {
    this.productosService
      .cListasPreciosCabeceras(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg)
      .subscribe((data: ListaPrecioCabecera[]) => {
        this.dataSourceCabeceras.data = [];
        if (data.length) {

          this.dataSourceCabeceras.data = data;


          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })
  }

  seleccionarCabecera(cab: ListaPrecioCabecera) {
    if (cab != this.cabSeleccionada) {
      this.cabSeleccionada = cab;
      this.cItems(0);

    }
  }

  cItems(idTipoMensaje: number) {
    if (this.cabSeleccionada != null) {

      this.productosService
        .cListaPrecioItems(this.cabSeleccionada.idPais, this.cabSeleccionada.idCompania, this.cabSeleccionada.idSalesOrg, this.cabSeleccionada.id, this.cabSeleccionada.idTerminoPago)
        .subscribe((data: ListaPrecioItem[]) => {
          this.dataSourceItems.data = [];
          if (data.length) {

            this.dataSourceItems.data = data;


            switch (idTipoMensaje) {
              case 1:
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
                break;
              case 2:
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
                break;
              case 3:
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
                break;

            }
          }
          if (!this.dataSourceItems.data.length) {
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, "Esta lista de precios no contiene ítems", 2, 1)
          }

        })
    }
  }

  applyFilterCabeceras(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCabeceras.filter = filterValue.trim().toLowerCase();
  }

  applyFilterItems(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceItems.filter = filterValue.trim().toLowerCase();
  }

  dialogCabecera(idTipo: number, lp: ListaPrecioCabecera) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { lp: lp, idTipo: idTipo }
    let dialogRef = this.dialog.open(ListasPreciosCabecerasDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.cCabeceras(idTipo);
      }
    })
  }

  eliminarCabecera(lp: ListaPrecioCabecera) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación de la cabecera " + lp.descripcion + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.productosService.bListaPrecioCabecera(lp).subscribe((data: boolean) => {

            this.cCabeceras(3);
          })
        }
      })
  }

  dialogItem(idTipo: number, i: ListaPrecioItem) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { i: i, idTipo: idTipo }
    let dialogRef = this.dialog.open(ListasPreciosItemsDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.cItems(idTipo);
      }
    })
  }

  eliminarItem(i: ListaPrecioItem) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del ítem " + i.descripcion + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.productosService.bListaPrecioItem(i).subscribe((data: boolean) => {

            this.cItems(3);
          })
        }
      })
  }

  exportarExcel() {
    if (this.cabSeleccionada != null) {

      if (this.dataSourceItems.data.length) {
        this.exporExcelService.cExcelListaPrecioItems(this.dataSourceItems.data, this.cabSeleccionada);
      }
    }
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


}
